import React from "react";
import ImgIconComp from '../../components/imgcomp';

const LoaderComp = function (props :any) {
  return (<div className="loading-comp"><ImgIconComp id="loadinggif" /></div>);
};

export default LoaderComp;